import Header from '../../components/Header'
import Footer from '../../components/Footer'
import Head from '../../components/Head'
import FundingModal from '../../components/modal/FundingModal'
import * as common from '../../common/commonFunction'
import commonSession from '../../common/commonSession'
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router'
import $ from 'jquery';
import { LOGIN_ALERT1 } from "../../lib/global_variable"
import { isMobile } from "react-device-detect";
import axios from 'axios'

// Import Swiper React components
import { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react'

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/autoplay';
import e from 'cors';

// funding 상세 페이지
const View = () => {

    var sessionInfo = commonSession.getSession()
    var auth = "Bearer " + sessionInfo.token;
    const router = useRouter()
    const [pollingResultId, setPollingResultId] = useState('');
    const [fundingList, setFundingList] = useState([]);
    const [fundingCnt, setFundingCnt] = useState([]);
    const [ticketAmount, setTicketAmount] = useState(100000);
    const [fundingInfo, setFundingInfo] = useState([]);
    const [extraData, setExtraData] = useState([]);
    const [fundingDday, setFundingDday] = useState(0);
    const [isActive, setIsActive] = useState(false);
    const [reload, setReload] = useState(false);
    const nl2br = require('react-nl2br');

    useEffect(() => {

        if (!router.isReady) return;

        const params = router.query;

        if (!params) {
            // 값이 없으면 메인으로 넘기기 처리 -- 1025
            window.location.href = '/';
            return false;
        }

        console.log(params.pollingResultId);

        if (params.pollingResultId && params.pollingResultId != '') {

            setPollingResultId(params.pollingResultId);

            const option = {
                url: "/funding?pollingResultId=" + params.pollingResultId,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    "Authorization": auth
                }
            }

            axios(option)
                .then(response => {
                    console.log(response);
                    if (response.status == 200) {
                        setFundingInfo(response.data.data);
                        setExtraData(response.data.extraData)
                        setFundingDday(getDDay(response.data.data.EndAt));
                        isActiveFunding(response.data.data.StartAt, response.data.data.EndAt);
                        getTicketInfo(response.data.data.TicketId);
                    }
                });
        } else {
            // 값이 없으면 메인으로 넘기기 처리 -- 1025
            window.location.href = '/';
        }

        // 카테고리 기준으로 투표결과 리스트 가져오기
        const option = {
            url: "/project/pollingResult/category?categoryID=P01_01_01",
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                "Authorization": auth
            }
        }

        axios(option)
            .then(response => {
                console.log(response);
                if (response.data.codeMsg != 'NO_DATA_ERROR' && response.data.codeMsg == 'SUCCESS') {
                    setFundingList(response.data.data);
                }
            });


        // 카테고리 기준으로 투표결과 리스트 가져오기
        const option1 = {
            url: "/project/pollingResult/category?categoryID=P01_01_02",
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                "Authorization": auth
            }
        }

        axios(option1)
            .then(response => {
                console.log(response);
                if (response.data.codeMsg != 'NO_DATA_ERROR' && response.data.codeMsg == 'SUCCESS') {
                    setFundingList(response.data.data);
                    setFundingCnt(response.data.data.length)
                }
            });


    }, [router.isReady])

    useEffect(() => {

        if (!reload) {

            $.each(fundingList, async function (i, e) {

                const option2 = {
                    url: "/funding?pollingResultId=" + e.pollingResultId,
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json;charset=UTF-8',
                        "Authorization": auth
                    }
                }

                await axios(option2)
                    .then(async result => {
                        e.fundingData = result.data.data

                        const startAt = new Date(result.data.data.StartAt);
                        const endAt = new Date(result.data.data.EndAt);
                        const today = new Date();

                        if (startAt <= today && endAt >= today) {
                            e.showBtn = true;
                            e.showBtnText = '프로젝트 더 알아보기'
                        } else {
                            e.showBtn = true;

                            if (startAt > today) {
                                e.showBtnText = '퍼블릭 세일 오픈 전';
                            } else {
                                e.showBtnText = '퍼블릭 세일 마감완료';
                            }
                        }

                        console.log(e);

                        // 시작고ㅓㅏ 끝까지 몇일이 남았는지를 저장시킨다. 
                        e.leftDate = common.getDDay(result.data.data.EndAt);
                        e.comeDate = common.getDDay(result.data.data.StartAt);

                        // 펀딩 진행 퍼센트 계산 
                        e.percentage = 0;
                        e.perClass = "percent-4"

                        if (result.data.extraData) {
                            e.percentage = (((result.data.extraData.totalTicket - result.data.extraData.remainTicket) / (result.data.extraData.totalTicket)) * 100).toFixed(2);

                            if (e.percentage >= 200) {
                                e.perClass = "percent-1"
                            } else if (e.percentage >= 150) {
                                e.perClass = "percent-2"
                            } else if (e.percentage >= 100) {
                                e.perClass = "percent-3"
                            }
                        }

                        if (fundingList.length < fundingCnt) {
                            setFundingList([...fundingList, e])
                        }

                        if (fundingCnt && i == (fundingCnt - 1)) {
                            setReload(true)
                        }

                    });
            })

        }

    }, [fundingList])

    const clickEvent = (e) => {
        $(e.target).parent('.qna-title').parent('qna-box').find('.content-box').toggle('fast');

        if (!$(e.target).parent('.qna-title').parent('.qna-box').hasClass('open')) {
            $(e.target).parent('.qna-title').parent('.qna-box').addClass('open');
        } else {
            $(e.target).parent('.qna-title').parent('.qna-box').removeClass('open');
        }
    }

    const getDDay = (expiry_date) => {
        // D-Day 날짜 지정
        const setDate = new Date(expiry_date); //열람만료일 기준
        //YMDFormatter 함수를 쓴 이유는 expiry_date가 "20220526" 형태로 넘어오기 때문에
        //한번 더 포맷 해줌

        // 현재 날짜를 new 연산자를 사용해서 Date 객체를 생성
        const now = new Date();

        // D-Day 날짜에서 현재 날짜의 차이를 getTime 메서드를 사용해서 밀리초의 값으로 가져온다.
        const distance = setDate.getTime() - now.getTime();
        // Math.floor 함수를 이용해서 근접한 정수값을 가져온다.
        // 밀리초 값이기 때문에 1000을 곱한다.
        // 1000*60 => 60초(1분)*60 => 60분(1시간)*24 = 24시간(하루)
        // 나머지 연산자(%)를 이용해서 시/분/초를 구한다.
        const day = Math.floor(distance / (1000 * 60 * 60 * 24));

        return day + 1;
    }

    // compare date for funding 
    function isActiveFunding(fundingStartAt, fundingEndAt) {

        console.log(fundingStartAt);
        console.log(fundingEndAt);

        const today = new Date(); //오늘 날짜 
        const startAt = new Date(fundingStartAt); //펀딩 시작일
        const EndAt = new Date(fundingEndAt); //펀딩 마감일

        console.log(today);
        console.log(startAt);
        console.log(EndAt);

        if (today >= startAt && today <= EndAt) {
            setIsActive(true);
        }
    }


    // 펀딩페이지로 이동 처리 
    const buyFundingTicket = (e) => {
        if (sessionInfo.token == null || sessionInfo.token == "") {
            alert(LOGIN_ALERT1);
            window.location.href = '/login';

        } else if (sessionInfo.certificated == null || sessionInfo.certificated === false || sessionInfo.certificated == false) {
            alert('계좌인증 후 구매가 가능합니다.');
            window.location.href = '/mymbId';
        } else {
            showModal()
        }
    }

    // 펀딩마감 알럿 노출처리
    const endFunding = (e) => {
        if (sessionInfo.token == null || sessionInfo.token == "") {
            alert(LOGIN_ALERT1);
            window.location.href = '/login';

        } else {
            alert('이미 세일이 마감된 펀딩입니다.')
            return false;
        }
    }

    // 모바일에 따라 노출 처리 -- kjy
    if (isMobile) {
        return (
            <>
                <Head />
                <Header />
                <link rel='stylesheet' href='/css/mobile/funding-view.min.css' />
                <div id="fundingView" className="container w-100 text-center">
                    <content>
                        <section>
                            <div className="img-box">
                                {/* <img src={`/img/funding_ex1.svg`} style={{ width: "100%" }}></img> */}
                                <img src={fundingInfo.ThumbnailLink ?? ''} style={{ width: "100%" }}></img>
                            </div>
                            <div className="title-box w-100">
                                <p className="explain-box">
                                    <div className="d-flex align-items-start justify-content-between">
                                        <div className="ex-item w-30 ps-1">
                                            <p className="explain-title text-center">{ticketAmount && ticketAmount <= 100000 ? '1차' : (ticketAmount <= 150000 ? '2차' : '프리미엄') + ` 판매`} 발행</p>
                                            <div className="explain-content">
                                                <p className="main-content text-center">{extraData ? Number(extraData.totalTicket).toLocaleString() : 0}EA</p>
                                            </div>
                                        </div>
                                        <div className="ex-item w-40">
                                            <p className="explain-title text-center">1EA</p>
                                            <div className="explain-content">
                                                <p className="main-content text-center tckt-price-text"><span className="text-em">{ticketAmount ? ticketAmount.toLocaleString() : 0}</span> ₩</p>
                                            </div>
                                        </div>
                                        <div className="ex-item w-30">
                                            <p className="explain-title text-center"><i className='icon-clock-color'></i>남은 기간</p>
                                            <div className="explain-content">
                                                <p className="main-content text-center"><span className="text-em">{fundingDday}일</span> 남음</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="progress-box">
                                        <div class="ticket-info-box d-inline-block w-100 text-end"><span class="all-ticket-count">잔여 <span class="text-em">{(extraData ? (extraData.remainTicket) : 0)} EA</span></span></div>
                                        <progress id="progress" value={fundingDday < 0 ? 100 : ((extraData ? (extraData.totalTicket - extraData.remainTicket) : 1) / (extraData ? (extraData.totalTicket) : 1)) * 100} min="0" max="100"></progress>
                                    </div>
                                    <div className='mt-0'>
                                        <p className="sub-content text-start">펀딩 완료 후 M.Funds 블록체인에서 일괄 발행.</p>
                                    </div>
                                </p>
                                <div className="btn-area">
                                    {isActive ? <button type="button" className="funding-buy-btn" onClick={buyFundingTicket} data-id={fundingInfo.fundingId ?? 0}>저작권 구매<br/>FUNDING</button> : <button type="button" className="funding-buy-btn" onClick={buyFundingTicket} data-id={fundingInfo.fundingId ?? 0} style={{ pointerEvents: "none", backgroundColor: "#ddd", color: "#939598", border: "1px solid #ddd !important;" }}>저작권 구매<br/>FUNDING</button>}
                                </div>
                            </div>
                        </section>
                        {fundingInfo.IntroMobImageLink && fundingInfo.IntroMobImageLink != '' ?

                            <section className="road-map-list w-100" style={{ magin: "0 auto" }}>
                                <img src={fundingInfo.IntroMobImageLink ?? ''} style={{ width: "100%" }}></img>
                            </section>
                            : <>
                                <section className="intro-funding-one w-80" style={{ magin: "0 auto" }}>
                                    <p className="title">작품소개</p>
                                    <div>
                                        <div className="">
                                            <img className="content-ticket-img" src="/img/funding_introduce.png"></img>
                                        </div>
                                        <div className="context w-100">
                                            {/* {fundingInfo.Genres ?? '작품 장르'} */}
                                            {nl2br(fundingInfo.CharacterIntro) ?? '캐릭터 소개 / 요약'}
                                        </div>
                                    </div>
                                </section>
                                <section className="intro-funding-two w-80" style={{ magin: "0 auto" }}>
                                    <div>
                                        <div className="">
                                            <p className="title" style={{ textAlign: "center" }}>시놉시스 요약</p>
                                        </div>
                                        <div className="context w-100">
                                            {nl2br(fundingInfo.Introduce) ?? '시놉시스 전문'}
                                        </div>
                                    </div>
                                </section>
                            </>
                        }
                        {/* {fundingInfo.IntroMobImageLink1 && fundingInfo.IntroMobImageLink1 != '' ?

                            <section className="road-map-list w-100" style={{ magin: "0 auto" }}>
                                <img src={fundingInfo.IntroMobImageLink1 ?? ''} style={{ width: "100%" }}></img>
                            </section>
                            : <>
                            </>
                        }
                        {fundingInfo.IntroMobImageLink2 && fundingInfo.IntroMobImageLink2 != '' ?

                            <section className="road-map-list w-100" style={{ magin: "0 auto" }}>
                                <img src={fundingInfo.IntroMobImageLink2 ?? ''} style={{ width: "100%" }}></img>
                            </section>
                            : <>
                            </>
                        } */}
                        {/* {fundingInfo.IntroMobImageLink3 && fundingInfo.IntroMobImageLink3 != '' ?

                            <section className="road-map-list w-100" style={{ magin: "0 auto" }}>
                                <img src={fundingInfo.IntroMobImageLink3 ?? ''} style={{ width: "100%" }}></img>
                            </section>
                            : <>
                            </>
                        } */}
                        {/* {fundingInfo.IntroMobImageLink4 && fundingInfo.IntroMobImageLink4 != '' ?

                            <section className="road-map-list w-100" style={{ magin: "0 auto" }}>
                                <img src={fundingInfo.IntroMobImageLink4 ?? ''} style={{ width: "100%" }}></img>
                            </section>
                            : <>
                            </>
                        } */}
                        {/* <section className="exp-prjt">
                            <img src="/img/renew-img/m_ex_project.svg"></img>
                        </section> */}
                        <section className="road-map-list faq-list">
                            <p className="title">FAQ</p>
                            <div className="context w-100">
                                <div className="qna-box">
                                    <p className="qna-title">Q1. ‘콘텐츠 제작 티켓’은 무엇인가요?<i className="dropdown-arrow" onClick={clickEvent}></i></p>
                                    <div className="content-box">
                                        <p className="qna-content">'콘텐츠 제작 티켓'이란 콘텐츠 제작 프로젝트에 참여할 수 있는 입장 티켓입니다. 또한, 저작권 지분을 의미하는 저작권_NFT로 개인이 콘텐츠의 제작 과정에 참여하고 공동 저작권자 될 수 있도록하는 최초의 저작권 투자의 기회입니다.</p>
                                    </div>
                                </div>
                                <div className="qna-box">
                                    <p className="qna-title">Q2. ‘콘텐츠 제작 티켓’을 구매 시 예상되는 수익 구조는 어떻게 되나요?<i className="dropdown-arrow" onClick={clickEvent}></i></p>
                                    <div className="content-box">
                                        <p className="qna-content">'콘텐츠 제작 티켓’을 구매하여 콘텐츠 제작에 참여함으로써 얻는 가장 큰 의미는 해당 작품의 공동저작권자가 된다는 의미 입니다.</p>
                                        <p className="qna-content">저작권자가 되면, 해당 작품에서 발생하는 다양한 수익에 대한 저작권자로서 권리를 챙겨가실 수 있습니다.</p>
                                        <p className="qna-content">국내 대형 제작사가 웹툰 제작을 하게 되며, 대한민국에 있는 모든 플랫폼 및 글로벌 플랫폼 비독점 투고 예정입니다. (국내 T사 m사 a사 / 해외 D사 C사 T사 등)</p>
                                        <p className="qna-content">이때 여기서 발생하는 웹툰 수익 중 저작권자에게 할당된 %에 따라 수익금이 정산됩니다.</p>
                                    </div>
                                </div>
                                <div className="qna-box">
                                    <p className="qna-title">Q3. 웹툰 제작사는 누구인가요?<i className="dropdown-arrow" onClick={clickEvent}></i></p>
                                    <div className="content-box">
                                        <p className="qna-content">이번 작품은 MFunds와의 계약을 맺은 국내 웹툰 전문 제작기업인 M사(추후 공개)에서 제작을 진행합니다.</p>
                                        <p className="qna-content">M사의 정보는 추후 공개됩니다.</p>
                                    </div>
                                </div>
                                <div className="qna-box">
                                    <p className="qna-title">Q4. 펀딩 모금이 완료되지 않는다면 환불이 되나요?<i className="dropdown-arrow" onClick={clickEvent}></i></p>
                                    <div className="content-box">
                                        <p className="qna-content">펀딩 목표액이 달성되지 않을 시에는 원칙적으로는 고객에게 환불 진행이 됩니다.</p>
                                        <p className="qna-content">다만, 환불을 원하지 않는 투자자들의 모금된 금액만을 가지고 작품 제작을 들어가게 됩니다.</p>
                                        <p className="qna-content">이 경우에 있어서 작품이 제작되어감에 따라 판매되지 않은 잔여 ‘콘텐츠 제작 티켓’의 판매 단가는 상승할 수 있습니다.</p>
                                    </div>
                                </div>
                                <div className="qna-box">
                                    <p className="qna-title">Q5.투자를 하기 위한 최소/최대 금액이 있나요?<i className="dropdown-arrow" onClick={clickEvent}></i></p>
                                    <div className="content-box">
                                        <p className="qna-content">투자의 최소 단위 금액은 콘텐츠 제작 티켓 1장이며,</p>
                                        <p className="qna-content">최대 단위 금액은 판매하는 총 400장의 콘텐츠 제작 티켓의 잔여 수량 전부 입니다.</p>
                                        <p className="qna-content">현재 판매되고 있는 콘텐츠 제작 티켓의 판매 가격 단위는 100,000원/1EA 입니다.</p>
                                    </div>
                                </div>
                                <div className="qna-box">
                                    <p className="qna-title">Q6. 펀딩이 성공적으로 종료된 후에는 어떻게 되나요?<i className="dropdown-arrow" onClick={clickEvent}></i></p>
                                    <div className="content-box">
                                        <p className="qna-content">펀딩이 성공적으로 종료된 후에는 웹툰 제작 단계로 진행이 되며,</p>
                                        <p className="qna-content">작품의 제작 진행 과정에 대해 DAO 기능을 통해 작품 진행 과정과 공지사항 등을 확인할 수 있습니다.</p>
                                    </div>
                                </div>
                                <div className="qna-box">
                                    <p className="qna-title">Q7.펀딩 진행 중에는 투자 금액을 변경할 수 있나요?<i className="dropdown-arrow" onClick={clickEvent}></i></p>
                                    <div className="content-box">
                                        <p className="qna-content">진행 중에는 환불이 가능하며, 더 많은 금액을 투자를 원하실 경우에는 추가로 콘텐츠 제작 티켓 구매를 진행하시면 됩니다.</p>
                                        <p className="qna-content">다만, 작품 제작이 진행된 이후의 환불은 불가능함에 유의해주시길 바랍니다.</p>
                                    </div>
                                </div>
                                <div className="qna-box">
                                    <p className="qna-title">Q8.결제 방식은 어떤 것이 있나요?<i className="dropdown-arrow" onClick={clickEvent}></i></p>
                                    <div className="content-box">
                                        <p className="qna-content">현재 작품별 계좌이체 방식과 토스 페이먼트 결제 시스템을 통한 간편 결제가 가능합니다.</p>
                                        <p className="qna-content">계좌이체 방식의 경우 수수료가 발생하지 않으나, 최종 확인 및 승인에 영업일 기준 최대 2일까지 소요될 수 있습니다.</p>
                                        <p className="qna-content">반면 토스 페이먼트를 통한 간편 결제의 경우 최종 확인에 소요 시간이 발생하지 않으나, 간편 결제시 발생하는 간편 결제 수수료 만큼 추후 이익금 정산시에 차감 후 정산됩니다.</p>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className="funding-list-box w-100" id="ing-prjt">
                            <div className="container">
                                <div className="menu-list-title">
                                    <div className='ms-2'>
                                        <p className="renew-main-content c-green">펀딩 중</p>
                                        <p className="renew-sub-content">PROJECT <span className='c-green'>OPEN NOW</span></p>
                                    </div>
                                    <div className='d-line l-green'></div>
                                </div>
                                <Swiper
                                    modules={[Autoplay, Pagination, Navigation]}
                                    pagination={{ clickable: true }}
                                    slidesPerView={2}
                                    navigation
                                    loop={false}
                                    className='swiper-container funding-list'
                                >
                                    {fundingList && fundingList.map((item, index) => {

                                        if (item.showBtnText == '프로젝트 더 알아보기') {
                                            return <SwiperSlide>
                                                <li className="funding-item">
                                                    <div className="img-box" onClick={() => (!item.showBtn ? buyFundingTicket('none') : buyFundingTicket(item.pollingResultId))}>
                                                        <img src={item.fundingData ? item.fundingData.ThumbnailLink : '/img/renew-img/project1.svg'} style={{ objectFit: "contain" }}></img>
                                                    </div>
                                                    <div className="content-box" onClick={() => (!item.showBtn ? buyFundingTicket('none') : buyFundingTicket(item.pollingResultId))}>
                                                        <span className="title" data-id={item.pollingResultId}>{item.fundingData ? item.fundingData.SynopsisTitle : item.synopsisTitle}</span>
                                                        <div className="writer-name d-flex align-items-center justify-content-between">
                                                            <div>
                                                                <span className={`percentage-text ` + item.perClass}>{item.percentage ?? 0} % </span>
                                                                <span className="status-text">Funded</span>
                                                            </div>
                                                            <span className='badge-item bg-funding'>funding</span>
                                                        </div>
                                                        <progress id={`progress-ing-` + index} className={item.perClass} value={item.percentage ?? 0} min="0" max="100"></progress>
                                                    </div>
                                                </li>
                                            </SwiperSlide>
                                        }
                                    })}
                                </Swiper>
                            </div>
                        </section>
                    </content>
                </div>
                <FundingModal fundingId={fundingInfo.FundingId ?? ''} bankAccount={fundingInfo.BankAccount ?? ''} bankName={fundingInfo.BankName ?? ''} ticketAmount={ticketAmount ?? 100000} ticketId={fundingInfo.TicketId ?? ''} remainTicket={extraData.remainTicket ?? 0} />
                <Footer />
            </>
        )
    } else {
        return (
            <>
                <Head />
                <Header />
                <link rel='stylesheet' href='/css/funding-view.min.css' />
                <div id="fundingView" className="container w-100 text-center">
                    <content>
                        <section>
                            <div className="item-box">
                                <div className="img-box">
                                    <img src={fundingInfo.ThumbnailLink ?? ''} style={{ width: "100%" }}></img>
                                </div>
                                <div className="title-box w-70">
                                    <p className="explain-box">
                                        <div className="d-flex align-items-start justify-content-between">
                                            <div className="ex-item w-33">
                                                <p className="explain-title text-center">{ticketAmount && ticketAmount <= 100000 ? '1차' : (ticketAmount <= 150000 ? '2차' : '프리미엄') + ` 판매`} 발행</p>
                                                <div className="explain-content">
                                                    <p className="main-content text-center"><span className="text-em">{extraData ? Number(extraData.totalTicket).toLocaleString() : 0}</span> EA</p>
                                                </div>
                                            </div>
                                            <div className="ex-item w-33">
                                                <p className="explain-title text-center">1EA</p>
                                                <div className="explain-content">
                                                    <p className="main-content text-center tckt-price-text"><span className="text-em">{ticketAmount ? ticketAmount.toLocaleString() : 0}</span> ₩</p>
                                                </div>
                                            </div>
                                            <div className="ex-item w-33">
                                                <p className="explain-title text-center"><i className='icon-clock-color'></i>남은 기간</p>
                                                <div className="explain-content">
                                                    <p className="main-content text-center"><span className="text-em">{fundingDday}일</span> 남음</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="progress-box">
                                            <div className="ticket-info-box">
                                                <progress id="progress" value={fundingDday < 0 ? 100 : ((extraData ? (extraData.totalTicket - extraData.remainTicket) : 1) / (extraData ? (extraData.totalTicket) : 1)) * 100} min="0" max="100"></progress>
                                                <span className="all-ticket-count">잔여 <span className="text-em">{(extraData ? (extraData.remainTicket) : 0)} EA</span></span>
                                            </div>
                                        </div>
                                        <div className='mt-0'>
                                            <p className="sub-content text-start">펀딩 완료 후 M.Funds 블록체인에서 일괄 발행.</p>
                                        </div>
                                    </p>
                                    <div className="btn-area">
                                        {isActive ? <button type="button" className="funding-buy-btn" onClick={buyFundingTicket} data-id={fundingInfo.fundingId ?? 0}>저작권 구매 <br/>FUNDING</button> : <button type="button" className="funding-buy-btn" onClick={buyFundingTicket} data-id={fundingInfo.fundingId ?? 0} style={{ pointerEvents: "none", backgroundColor: "#ddd", color: "#939598", border: "1px solid #ddd !important;" }}>저작권 구매<br/>FUNDING</button>}
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* <section className="road-map-list">
                            <p className="title">작품요약</p>
                            <p className='road-map-content'>{nl2br(fundingInfo.CharacterIntro) ?? '작품요약'}</p>
                        </section> */}

                        {fundingInfo.IntroImageLink && fundingInfo.IntroImageLink != '' ?

                            <section className="road-map-list">
                                <img src={fundingInfo.IntroImageLink ?? ''} style={{ width: "100%" }}></img>
                            </section>
                            :

                            <>
                                <section className="intro-funding-one">
                                    <p className="title mb3" style={{ textAlign: "right" }}>작품소개</p>
                                    <div>
                                        <div className="context">
                                            {/* {fundingInfo.Genres ?? '작품 장르'} */}
                                            {nl2br(fundingInfo.CharacterIntro) ?? '캐릭터 소개 / 요약'}
                                        </div>
                                        <div className="">
                                            <img className="content-ticket-img" src="/img/funding_introduce.png"></img>
                                        </div>
                                    </div>
                                </section>
                                <section className="intro-funding-two">
                                    <p className="title mb3" style={{ marginLeft: "51pt", textAlign: "left" }}>시놉시스 요약</p>
                                    <div>
                                        <div>
                                            <img className="content-ticket-img" src="/img/funding_introduce_book.png"></img>
                                        </div>
                                        <div className="context">
                                            {nl2br(fundingInfo.Introduce) ?? '시놉시스 전문'}
                                        </div>
                                    </div>
                                </section>
                            </>
                        }
                        {/* {fundingInfo.IntroImageLink1 && fundingInfo.IntroImageLink1 != '' ?

                            <section className="road-map-list">
                                <img src={fundingInfo.IntroImageLink1 ?? ''} style={{ width: "100%" }}></img>
                            </section>
                            :

                            <>
                            </>
                        }
                        {fundingInfo.IntroImageLink2 && fundingInfo.IntroImageLink2 != '' ?

                            <section className="road-map-list">
                                <img src={fundingInfo.IntroImageLink2 ?? ''} style={{ width: "100%" }}></img>
                            </section>
                            :

                            <>
                            </>
                        } */}
                        {/* {fundingInfo.IntroImageLink3 && fundingInfo.IntroImageLink3 != '' ?

                            <section className="road-map-list">
                                <img src={fundingInfo.IntroImageLink3 ?? ''} style={{ width: "100%" }}></img>
                            </section>
                            :

                            <>
                            </>
                        } */}
                        {/* {fundingInfo.IntroImageLink4 && fundingInfo.IntroImageLink4 != '' ?

                            <section className="road-map-list">
                                <img src={fundingInfo.IntroImageLink4 ?? ''} style={{ width: "100%" }}></img>
                            </section>
                            :

                            <>
                            </>
                        } */}
                        {/* <section className="exp-prjt">
                            <img src="/img/renew-img/ex_project.svg"></img>
                        </section> */}
                        <section className="road-map-list faq-list">
                            <p className="title">FAQ</p>
                            <div className="context w-100">
                                <div className="qna-box">
                                    <p className="qna-title">Q1. ‘콘텐츠 제작 티켓’은 무엇인가요?<i className="dropdown-arrow" onClick={clickEvent}></i></p>
                                    <div className="content-box">
                                        <p className="qna-content">'콘텐츠 제작 티켓'이란 콘텐츠 제작 프로젝트에 참여할 수 있는 입장 티켓입니다. 또한, 저작권 지분을 의미하는 저작권_NFT로 개인이 콘텐츠의 제작 과정에 참여하고 공동 저작권자 될 수 있도록하는 최초의 저작권 투자의 기회입니다.</p>
                                    </div>
                                </div>
                                <div className="qna-box">
                                    <p className="qna-title">Q2. ‘콘텐츠 제작 티켓’을 구매 시 예상되는 수익 구조는 어떻게 되나요?<i className="dropdown-arrow" onClick={clickEvent}></i></p>
                                    <div className="content-box">
                                        <p className="qna-content">'콘텐츠 제작 티켓’을 구매하여 콘텐츠 제작에 참여함으로써 얻는 가장 큰 의미는 해당 작품의 공동저작권자가 된다는 의미 입니다.</p>
                                        <p className="qna-content">저작권자가 되면, 해당 작품에서 발생하는 다양한 수익에 대한 저작권자로서 권리를 챙겨가실 수 있습니다.</p>
                                        <p className="qna-content">국내 대형 제작사가 웹툰 제작을 하게 되며, 대한민국에 있는 모든 플랫폼 및 글로벌 플랫폼 비독점 투고 예정입니다. (국내 T사 m사 a사 / 해외 D사 C사 T사 등)</p>
                                        <p className="qna-content">이때 여기서 발생하는 웹툰 수익 중 저작권자에게 할당된 %에 따라 수익금이 정산됩니다.</p>
                                    </div>
                                </div>
                                <div className="qna-box">
                                    <p className="qna-title">Q3. 웹툰 제작사는 누구인가요?<i className="dropdown-arrow" onClick={clickEvent}></i></p>
                                    <div className="content-box">
                                        <p className="qna-content">이번 작품은 MFunds와의 계약을 맺은 국내 웹툰 전문 제작기업인 M사(추후 공개)에서 제작을 진행합니다.</p>
                                        <p className="qna-content">M사의 정보는 추후 공개됩니다.</p>
                                    </div>
                                </div>
                                <div className="qna-box">
                                    <p className="qna-title">Q4. 펀딩 모금이 완료되지 않는다면 환불이 되나요?<i className="dropdown-arrow" onClick={clickEvent}></i></p>
                                    <div className="content-box">
                                        <p className="qna-content">펀딩 목표액이 달성되지 않을 시에는 원칙적으로는 고객에게 환불 진행이 됩니다.</p>
                                        <p className="qna-content">다만, 환불을 원하지 않는 투자자들의 모금된 금액만을 가지고 작품 제작을 들어가게 됩니다.</p>
                                        <p className="qna-content">이 경우에 있어서 작품이 제작되어감에 따라 판매되지 않은 잔여 ‘콘텐츠 제작 티켓’의 판매 단가는 상승할 수 있습니다.</p>
                                    </div>
                                </div>
                                <div className="qna-box">
                                    <p className="qna-title">Q5.투자를 하기 위한 최소/최대 금액이 있나요?<i className="dropdown-arrow" onClick={clickEvent}></i></p>
                                    <div className="content-box">
                                        <p className="qna-content">투자의 최소 단위 금액은 콘텐츠 제작 티켓 1장이며,</p>
                                        <p className="qna-content">최대 단위 금액은 판매하는 총 400장의 콘텐츠 제작 티켓의 잔여 수량 전부 입니다.</p>
                                        <p className="qna-content">현재 판매되고 있는 콘텐츠 제작 티켓의 판매 가격 단위는 100,000원/1EA 입니다.</p>
                                    </div>
                                </div>
                                <div className="qna-box">
                                    <p className="qna-title">Q6. 펀딩이 성공적으로 종료된 후에는 어떻게 되나요?<i className="dropdown-arrow" onClick={clickEvent}></i></p>
                                    <div className="content-box">
                                        <p className="qna-content">펀딩이 성공적으로 종료된 후에는 웹툰 제작 단계로 진행이 되며,</p>
                                        <p className="qna-content">작품의 제작 진행 과정에 대해 DAO 기능을 통해 작품 진행 과정과 공지사항 등을 확인할 수 있습니다.</p>
                                    </div>
                                </div>
                                <div className="qna-box">
                                    <p className="qna-title">Q7.펀딩 진행 중에는 투자 금액을 변경할 수 있나요?<i className="dropdown-arrow" onClick={clickEvent}></i></p>
                                    <div className="content-box">
                                        <p className="qna-content">진행 중에는 환불이 가능하며, 더 많은 금액을 투자를 원하실 경우에는 추가로 콘텐츠 제작 티켓 구매를 진행하시면 됩니다.</p>
                                        <p className="qna-content">다만, 작품 제작이 진행된 이후의 환불은 불가능함에 유의해주시길 바랍니다.</p>
                                    </div>
                                </div>
                                <div className="qna-box">
                                    <p className="qna-title">Q8.결제 방식은 어떤 것이 있나요?<i className="dropdown-arrow" onClick={clickEvent}></i></p>
                                    <div className="content-box">
                                        <p className="qna-content">현재 작품별 계좌이체 방식과 토스 페이먼트 결제 시스템을 통한 간편 결제가 가능합니다.</p>
                                        <p className="qna-content">계좌이체 방식의 경우 수수료가 발생하지 않으나, 최종 확인 및 승인에 영업일 기준 최대 2일까지 소요될 수 있습니다.</p>
                                        <p className="qna-content">반면 토스 페이먼트를 통한 간편 결제의 경우 최종 확인에 소요 시간이 발생하지 않으나, 간편 결제시 발생하는 간편 결제 수수료 만큼 추후 이익금 정산시에 차감 후 정산됩니다.</p>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className="funding-list-box w-100" id="ing-prjt">
                            <div className="container">
                                <div className="menu-list-title">
                                    <div className='ms-2'>
                                        <p className="renew-main-content c-green">펀딩 중</p>
                                        <p className="renew-sub-content">PROJECT <span className='c-green'>OPEN NOW</span></p>
                                    </div>
                                    <div className='d-line l-green'></div>
                                </div>
                                <Swiper
                                    modules={[Autoplay, Pagination, Navigation]}
                                    pagination={{ clickable: true }}
                                    slidesPerView={4}
                                    navigation
                                    loop={false}
                                    className='swiper-container funding-list'
                                >
                                    {fundingList && fundingList.map((item, index) => {
                                        if (item.showBtnText == '프로젝트 더 알아보기') {
                                            return <SwiperSlide>
                                                <li className="funding-item">
                                                    <div className="img-box" onClick={() => (!item.showBtn ? buyFundingTicket('none') : buyFundingTicket(item.pollingResultId))}>
                                                        <img src={item.fundingData ? item.fundingData.ThumbnailLink : '/img/renew-img/project1.svg'} style={{ objectFit: "contain" }}></img>
                                                    </div>
                                                    <div className="content-box" onClick={() => (!item.showBtn ? buyFundingTicket('none') : buyFundingTicket(item.pollingResultId))}>
                                                        <span className="title" data-id={item.pollingResultId}>{item.fundingData ? item.fundingData.SynopsisTitle : item.synopsisTitle}</span>
                                                        <div className="writer-name d-flex align-items-center justify-content-between">
                                                            <div>
                                                                <span className={`percentage-text ` + item.perClass}>{item.percentage ?? 0} % </span>
                                                                <span className="status-text">Funded</span>
                                                            </div>
                                                            <span className='badge-item bg-funding'>funding</span>
                                                        </div>
                                                        <progress id={`progress-ing-` + index} className={item.perClass} value={item.percentage ?? 0} min="0" max="100"></progress>
                                                    </div>
                                                </li>
                                            </SwiperSlide>
                                        }
                                    })}
                                </Swiper>
                            </div>
                        </section>
                    </content>
                </div>
                <FundingModal fundingId={fundingInfo.FundingId ?? ''} bankAccount={fundingInfo.BankAccount ?? ''} bankName={fundingInfo.BankName ?? ''} ticketAmount={ticketAmount ?? 100000} ticketId={fundingInfo.TicketId ?? ''} remainTicket={extraData.remainTicket ?? 0} />
                <Footer />
            </>
        )
    }

    function showModal() {
        $('#fundingModalPopup').show();
    }

    function getTicketInfo(ticketId) {
        const option = {
            url: "/ticket?ticketId=" + ticketId,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                "Authorization": auth
            }
        }

        axios(option)
            .then(response => {
                console.log(response);
                if (response.status == 200) {
                    setTicketAmount(Number(response.data.data.TicketAmount))
                }
            });
    }

}
export default View;